/**
 * Fullscreen 404 page for custom domains without published agents
 * Displayed when a user visits a custom domain that either:
 * - Does not exist in the database
 * - Has an associated agent that is not published
 */

import { AlertTriangle } from "lucide-react";

/**
 * DomainNotFoundPage Component
 * Renders a fullscreen 404 error page for invalid custom domains
 */
export function DomainNotFoundPage() {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-6 text-center max-w-md px-4">
        <div className="rounded-full bg-muted p-4">
          <AlertTriangle className="h-12 w-12 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Page Not Found</h1>
          <p className="text-muted-foreground">
            The agent you're looking for doesn't exist or is no longer available.
          </p>
        </div>
      </div>
    </div>
  );
}
